import { useTranslation } from 'next-i18next'

import BgPattern from '~/landing/components/BgPattern'
import { useLandingEntryRoute } from '~/landing/contexts/landingEntryRoute'
import StartAnalytics from '~/analytics/start/startAnalytics'
import Button from '~/components/Buttons/Button'

export default function KnowledgeGaps({
  buttonClassName,
  onClick,
}: {
  buttonClassName?: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}): React.ReactElement {
  const { t } = useTranslation('landing')
  const entryRoute = useLandingEntryRoute()

  const handleButtonClick = (): void => {
    StartAnalytics.logCtaClick('onboarding_cta', 'landing_section_8_cta')
  }

  return (
    <div className="relative flex flex-col justify-center items-center px-2 py-12 text-center text-white bg-gradient-to-r from-purple-plum to-purple-indigo">
      <BgPattern className="!opacity-10" />
      <h2 className="text-8 md:text-h2 font-bold max-w-screen-19/20 md:max-w-3xl leading-tight">
        {t('knowledgeGaps.ready')}
      </h2>
      <p className="text-md text-blue-pastel mt-4 max-w-3xl">{t('knowledgeGaps.mapKnowledge')}</p>
      <Button
        className={
          buttonClassName ||
          '!bg-green-lime !text-black border-4 rounded-full mt-4 md:mt-8 px-8 py-2 text-md !font-black hover:scale-110 duration-100 z-10'
        }
        href={onClick ? undefined : entryRoute}
        onClick={onClick || handleButtonClick}
      >
        {t('knowledgeGaps.start')}
      </Button>
    </div>
  )
}
